<div fxLayout="column" *ngIf="job" style="overflow: auto;">

  <div fxFlex="100" fxLayout="row" *ngIf="!job.exitCode">
<!--    <mat-progress-spinner style="margin:0 auto;" mode="indeterminate"></mat-progress-spinner>-->
    <div  aria-label="Orange and tan hamster running in a metal wheel" role="img" class="wheel-and-hamster">
      <div class="wheel"></div>
      <div class="hamster">
        <div class="hamster__body">
          <div class="hamster__head">
            <div class="hamster__ear"></div>
            <div class="hamster__eye"></div>
            <div class="hamster__nose"></div>
          </div>
          <div class="hamster__limb hamster__limb--fr"></div>
          <div class="hamster__limb hamster__limb--fl"></div>
          <div class="hamster__limb hamster__limb--br"></div>
          <div class="hamster__limb hamster__limb--bl"></div>
          <div class="hamster__tail"></div>
        </div>
      </div>
      <div class="spoke"></div>
    </div>
  </div>

  <h3 style="margin-top: 15px !important; text-align: center" *ngIf="!job.exitCode">{{title}}</h3>


  <div fxFlex="100" fxLayout="row" *ngIf="job.exitCode && job.exitCode !== 200">
    <mat-error>
      {{error}} {{job.exitCode}}.
      <ng-container *ngIf="job.exitCode === 404">Brak elementów do przetworzenia</ng-container>
      <ng-container *ngIf="job.exitCode === 405">{{job.output}}</ng-container>
    </mat-error>
  </div>
</div>
